import { formatMessage } from '../../Localization/formatMessage';
import Messages from '../../Localization/Messages';

export const updateBreadcrumbs = addBreadcrumbs => {
  addBreadcrumbs([
    {
      trackingName: 'agentConversionPage',
      link: '/salescodeconversions',
      title: formatMessage(Messages.breadcrumb_agentConversionPage),
    },
  ]);
};
